import { validateAccessPolicy } from '../../api/src/auth/permissions';
import type { User } from './api/types';

export function validateUser(user: User): User {
  if (!['viewer', 'editor', 'superadmin'].includes(user.role))
    throw new Error('Неизвестная роль пользователя');
  return { ...user, access: validateAccessPolicy(user.access) };
}
// A late response cannot undo a newer policy. A different grant is accepted only by /me.
export function mergeAccessUser(
  current: User | null,
  incoming: User,
  observedGrantId?: string,
): User | null {
  if (!current || current.id !== incoming.id) return current;
  if (
    current.access.grantId !== incoming.access.grantId &&
    observedGrantId !== current.access.grantId
  )
    return current;
  if (
    current.access.grantId === incoming.access.grantId &&
    current.access.revision > incoming.access.revision
  )
    return current;
  return incoming;
}
